import React from "react";
import { Icon } from "@iconify/react";
import "../common/Header.css";

const ConfirmationModal = ({
  show = false,
  title = "Confirm Action",
  message = "Are you sure you want to continue?",
  icon = "et:hourglass",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
    loadingMessage, // ✅ fix typo here
}) => {
  if (!show) return null;

  return (
    <div className="prompt-overlay">
      <div className="prompt-box">
       {loading ? (
          // 🔵 Spinner + message while loading
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ height: "150px", gap: "1rem" }}
          >
            <div
              className="spinner-border text-primary"
              role="status"
              style={{ width: "4rem", height: "4rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="fs-5">{loadingMessage}</p> {/* ✅ Show the loading message */}
          </div>
        ) : (
          <>        <div className="d-flex justify-content-center align-item-center">
          <div className="Loading-icon">
            <Icon icon={icon} className="fs-4" />
          </div>
        </div>
        <h3 className="prompt-title">{title}</h3>
        <p>{message}</p>
        <div className="prompt-actions">
          <button onClick={onCancel} className="cancel-button">
            {cancelLabel}
          </button>
          <button onClick={onConfirm} className="confirm-button">
            {confirmLabel}
          </button>
        </div>
        </>

           )}
      </div>
    </div>
  );
};

export default ConfirmationModal;
